<template>
  <v-container class="auth-container" max-width="400">
    <v-card elevation="2" class="pa-6">
      <v-card-title class="text-h5 text-center">Forgot Password</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="handleReset" ref="form">
          <v-text-field
            v-model="email"
            label="Email Address"
            type="email"
            required
            prepend-icon="mdi-email"
          ></v-text-field>

          <v-btn
            type="submit"
            color="primary"
            class="mt-4"
            block
          >
            Send Reset Link
          </v-btn>

          <v-btn
            to="/login"
            variant="text"
            class="mt-2"
            block
          >
            Back to Login
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    handleReset() {
      alert(`Password reset link sent to ${this.email}`)
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}
</style>
